export async function deliverUsageLogSnapshot({ usageLog, fetchApi, onAccepted }) {
    if (!Array.isArray(usageLog) || usageLog.length === 0) {
        return { accepted: false, sent: 0 };
    }
    const snapshot = usageLog.slice();
    try {
        const response = await fetchApi(
            '/api/usageLogs/',
            { method: 'POST', publish: false },
            { usage: snapshot },
        );
        if (response?.status !== 201) {
            return { accepted: false, sent: snapshot.length };
        }
        onAccepted(snapshot.length);
        return { accepted: true, sent: snapshot.length };
    } catch (error) {
        return { accepted: false, sent: snapshot.length };
    }
}
